var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav-list',{attrs:{"nav":_vm.nav,"_class":("main-nav -prefixed " + _vm._class)}})}
var staticRenderFns = []

export { render, staticRenderFns }